import { render, staticRenderFns } from "./top-breadcrumb.vue?vue&type=template&id=18638e6d&scoped=true"
import script from "./top-breadcrumb.vue?vue&type=script&lang=js"
export * from "./top-breadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18638e6d",
  null
  
)

export default component.exports